import { render, staticRenderFns } from "./PackagingCostsComponent.vue?vue&type=template&id=3bcdebf8&"
import script from "./PackagingCostsComponent.vue?vue&type=script&lang=js&"
export * from "./PackagingCostsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports